import {setupConsentPersistence, handleConsentRequested} from '../../../usercentrics';

setupConsentPersistence(window.pageflow.consent);

handleConsentRequested({
  consent: window.pageflow.consent,
  usercentricsSettingsId: window.PAGEFLOW_USERCENTRICS_SETTINGS_ID
});
